import TemplateHeader from "components/Header";
import LoadingOverlay from "components/Indicator/LoadingOverlay";
import TemplateSidemenu from "components/Menu/Sidemenu";
import CustomModal from "components/Modal";
import Pagination from "components/Pagination";
import CustomTable from "components/Table";
import TemplateContainerMain from "components/Template";
import PageTitle from "components/Title/PageTitle";
import moment from "moment";
import { Component } from "react";
import _ from "lodash";
import { RolesPermission } from "Config";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { Card, CardBody, Col, Row } from "reactstrap";
import { compose } from "redux";
import FilterForm from "./Form";
import ReportAPI from "./action.js";
import { CheckUserRolesPermissons } from "actions/roles";

class RevenueReport extends Component {
	state = {
		filterQuery: "",
	};

	componentDidMount = () => {
		let tempModule = _.find(RolesPermission, {
			moduleID: CheckUserRolesPermissons(this.props.data.ProfileReducer.profile.roles).id,
		});

		if (tempModule && !tempModule.permissions.includes(13)) {
			return this.props.history.push("/");
		}
		this.props.getReport();
	};

	componentDidUpdate = (pp) => {
		const { reportPages, getReport } = this.props;
		const { filterQuery } = this.state;
		if (pp.reportPages !== reportPages) {
			getReport(`${!!filterQuery ? filterQuery : ""}`);
		}
	};

	renderReportTable = () => {
		const { reportList, onLoad } = this.props;
		return (
			<CustomTable
				data={reportList}
				showPagination={false}
				loading={onLoad}
				columnsContent={[
					{
						Header: "Invoice Date",
						accessorKey: "invoice_date",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return (
								<>
									{val.invoice_date
										? moment(val.invoice_date).format("DD/MM/YYYY hh:mm A")
										: ""}
								</>
							);
						},
					},
					{
						Header: "Date Of Editing",
						accessorKey: "date_of_editing",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return (
								<>
									{val.date_of_editing
										? moment(val.date_of_editing).format("DD/MM/YYYY hh:mm A")
										: ""}
								</>
							);
						},
					},
					{
						Header: "Post ID",
						accessorKey: "post_id",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.post_id}</>;
						},
					},
					{
						Header: "Order No.",
						accessorKey: "order_no",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.order_no}</>;
						},
					},
					{
						Header: "Advertiser Name",
						accessorKey: "advertiser_name",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.advertiser_name}</>;
						},
					},
					{
						Header: "Selling Price",
						accessorKey: "selling_price",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.selling_price}</>;
						},
					},
					{
						Header: "Price After Tax",
						accessorKey: "price_after_tax",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.price_after_tax}</>;
						},
					},
					{
						Header: "Last Editing User (Admin)",
						accessorKey: "last_edit_user",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.last_edit_user}</>;
						},
					},
					{
						Header: "Agent Code",
						accessorKey: "agent_code",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.agent_code}</>;
						},
					},
					{
						Header: "Agent Name",
						accessorKey: "agent_name",
						centerColumn: true,
						isStatusButton: false,
						Cell: (val) => {
							return <>{val.agent_name}</>;
						},
					},
				]}
			/>
		);
	};

	renderFilterModal = () => {
		const { getReport, onChangeHOC, showFilterModal } = this.props;

		const customSetState = (newState) => {
			this.setState(newState);
		};

        const handleSubmit = (filterQuery) => {
            getReport(filterQuery);
            onChangeHOC("filterQuery", filterQuery);
        }

		return (
			<CustomModal
				size={"lg"}
				title="In House Ads Report Filter"
				isOpen={showFilterModal}
				onClose={() => onChangeHOC("showFilterModal", false)}>
				<FilterForm
					onSubmit={handleSubmit}
					onChangeHOC={onChangeHOC}
					handleState={customSetState}
				/>
			</CustomModal>
		);
	};

	render = () => {
		const { onChangeHOC, reportPages, reportCount } = this.props;

		return (
			<>
				<TemplateContainerMain>
					<TemplateHeader
						onClickToggleProfileModal={() => {}}
						history={this.props.history}
						user={this.props.data.ProfileReducer.profile}
					/>
					<div className="app-main">
						<TemplateSidemenu
							userPermissions={this.props.userPermissions}
							user={this.props.user}
							userRole={this.props.userRole}
						/>
						<div className="app-main__outer">
							<div className="app-main__inner">
								<>
									<PageTitle
										heading="In House Ads Report"
										buttons={[
											{
												color: "",
												className: "btn-outline-primary mr-2",
												onClick: () => { this.props.exportReport() },
												content: (
													<>
														<span>Export</span>
													</>
												),
											},
											{
												color: "",
												className: "btn-outline-primary",
												onClick: () => onChangeHOC("showFilterModal", true),
												content: (
													<>
														<span>Filter</span>
													</>
												),
											},
										]}
									/>
									<ReactCSSTransitionGroup
										component="div"
										transitionName="TabsAnimation"
										transitionAppear={true}
										transitionAppearTimeout={0}
										transitionEnter={false}
										transitionLeave={false}>
										<Row>
											<Col md={12} style={{minWidth: 'max-content'}}>
												<Card className="main-card mb-3">
													<CardBody>
														{this.renderReportTable()}
														<Pagination
															pageIndex={reportPages}
															totalCount={reportCount}
															onChangePage={(val) =>
																onChangeHOC("reportPages", val)
															}
														/>
													</CardBody>
												</Card>
											</Col>
										</Row>
									</ReactCSSTransitionGroup>
									{this.renderFilterModal()}
									{this.props.onLoad && <LoadingOverlay />}
								</>
							</div>
						</div>
					</div>
				</TemplateContainerMain>
			</>
		);
	};
}

export default compose(ReportAPI)(RevenueReport);
